export default [{
	titulo: 'Governança e Gestão',
	icone: 'menu-icon fa fa-caret-right',
	url: '/site/governanca-e-gestao',
	visualizar: false,
	actions: [{
		value: false,
		name: 'Cadastrar'
	}, {
		value: false,
		name: 'Editar'
	}, {
		value: false,
		name: 'Apagar'
	}]
}]